'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Button } from '../button/button.js';
import { setReactInputValue } from '../Combobox/utilities.js';

/**
 * SearchClear component, used to display a clear button when the search input is not empty.
 *
 * @example
 * <Search>
 *   <SearchInput aria-label='Søk' />
 *   <SearchClear />
 * </Search>
 */
const SearchClear = forwardRef(function SearchClear({ 'aria-label': label = 'Tøm', onClick, ...rest }, ref) {
    const handleClear = (e) => {
        const target = e.target;
        let input = null;
        if (target instanceof HTMLElement)
            input = target.closest('.ds-search')?.querySelector('input');
        if (!input)
            throw new Error('Input is missing');
        /* narrow type to make TS happy */
        if (!(input instanceof HTMLInputElement))
            throw new Error('Input is not an input element');
        e.preventDefault();
        setReactInputValue(input, '');
        input.focus();
        onClick?.(e);
    };
    return (jsx(Button, { ref: ref, variant: 'tertiary', type: 'reset', "aria-label": label, onClick: handleClear, icon: true, ...rest }));
});

export { SearchClear };
